define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, UserContext) {
    "use strict";
    var CustomerNotes = /** @class */ (function () {
        function CustomerNotes() {
            this.filterByAny = ko.observable("");
            this.canExport = ko.observable(UserContext.hasAccess("Admin,OfficeLocations.Export"));
        }
        CustomerNotes.prototype.init = function () {
            var self = this;
            $("#page-title").text("Customer Notes");
            tools.ajaxGet({
                url: "/CustomerNotes/GetNotesLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid(self.lookupLists.GridStructures.CustomerNotesStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        CustomerNotes.prototype.initGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            //add actions column
            self.mainTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CustomerNotes/GetNotes",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    },
                    sort: { field: "CreatedOn", dir: "desc" }
                },
                gridOptions: {
                    toolbar: kendo.template($("#customer-notes-toolbar-template").html()),
                    columns: columns,
                    autoBind: true,
                    resizable: true,
                    reorderable: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    }
                },
                enableExport: {
                    entityName: "CustomerNotes",
                    title: "Customer Notes",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                gridId: "tblCustomerNotes",
                showPagerOnTop: false,
                controller: self
            };
            self.mainTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.mainTable.refresh();
            });
        };
        CustomerNotes.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        CustomerNotes.prototype.exportTo = function () {
            var self = this;
            if (self.canExport) {
                self.mainTable.exportTo();
            }
        };
        CustomerNotes.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("CustomerNotes");
                dataLogs.open("Customer Notes logs");
                event.preventDefault();
            }
        };
        CustomerNotes.prototype.savePageSettings = function () {
        };
        return CustomerNotes;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/CustomerNotes/Index")) {
            log.log("Initialize CustomerNotes list");
            $(function () {
                (new CustomerNotes()).init();
            });
        }
    }, 0);
    return CustomerNotes;
});
//# sourceMappingURL=customerNotes.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerNotes.js
// module id = 207
// module chunks = 2